/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "./Base"
import {greys} from "../../global/colors"

const DotDotDot = ({color = greys.mediumDark, ...props}) => (
  <BaseSvgIcon color={color} {...props} viewBox="0 0 16 16">
    <circle cx="8" cy="8" r="7" fill="none" stroke={color} strokeWidth={1} />
    <circle cx="4" cy="8" r="1" />
    <circle cx="8" cy="8" r="1" />
    <circle cx="12" cy="8" r="1" />
  </BaseSvgIcon>
)

export default DotDotDot
